import { useState } from 'react';

const Dropdown = ({
	buttonText = 'Ouvrir',
	options = [],
	placeholder = 'Recherche',
	isObject = false,
	keyToFind = '',
	multiKeys = [],
	classes = 'flex items-center justify-center',
	isDisabled = false,
	setCanLoadMoreOptions = () => {},
	customHeightClass = 'h-[150px]',
	onOptionSelect,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const [searchTerm, setSearchTerm] = useState('');
	const [closeDiv, setCloseDiv] = useState(false);

	const toggleDropdown = () => {
		setCloseDiv(false);
	
		if (!isDisabled) {
			setIsOpen(!isOpen);
		}
	};

	const isLastOption = (event) => {
		const element = event.target;
		const isAtBottom = element.scrollHeight - element.scrollTop === element.clientHeight;

		if (isAtBottom) {
			setCanLoadMoreOptions(true);
		}
	};

	const filteredOptions = options.filter((option) => {
		if (isObject && multiKeys.length > 0) {
			return multiKeys.some((key) => option[key].toLowerCase().includes(searchTerm.toLowerCase()));
		}

		if (isObject && multiKeys.length === 0) {
			return option[keyToFind].toLowerCase().includes(searchTerm.toLowerCase());
		} else {
			return option.toLowerCase().includes(searchTerm.toLowerCase());
		}
	});

	const handleClick = (event, option) => {
		event.preventDefault();
		onOptionSelect(option);
		setIsOpen(false);
	}

	return (
		<>
			<button type="button" onClick={toggleDropdown} className={classes} disabled={isDisabled}>
				<span className="mr-2 capitalize">{buttonText.replace('-', ' ')}</span>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					className="w-5 h-5 ml-2 -mr-1"
					viewBox="0 0 20 20"
					fill="currentColor"
					aria-hidden="true"
				>
					<path
						fillRule="evenodd"
						d="M6.293 9.293a1 1 0 011.414 0L10 11.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
						clipRule="evenodd"
					/>
				</svg>
			</button>
			{((isOpen && !isDisabled) && !closeDiv) && (
				<div className="absolute right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1 w-full z-20 lg:w-full">
					{/* Search input */}
					<input
						type="text"
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
						className="block w-full px-4 py-2 text-gray-800 border rounded-md border-gray-300 focus:outline-none"
						placeholder={placeholder}
						autoComplete="off"
					/>
					{/* Dropdown content */}
					<div className={`${customHeightClass} overflow-y-auto`} onScroll={isLastOption}>
						{filteredOptions.length > 0 ? (
							filteredOptions.map((option, index) => (
								<button
									type="button"
									key={index}
									onClick={(event) => handleClick(event, option)}
									className="block px-4 py-2 text-gray-700 hover:bg-gray-100 active:bg-blue-100 cursor-pointer rounded-md"
								>
									{isObject
										? multiKeys.length > 0
											? multiKeys.map((key) => option[key]).join(' - ').split('-')
											.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
											.join(' ')
											: option[keyToFind]
										: option}
								</button>
							))
						) : (
							<div className="px-4 py-2 text-gray-500">Aucun résultat</div>
						)}
					</div>
				</div>
			)}
		</>
	);
};

export default Dropdown;
